/* Kaddanse — date de livraison en clair (R7).
   Traduit les faits boutique (coupure 17 h Paris lun–ven, préparation 1–2 j
   ouvrés, acheminement 5–8 j ouvrés) en une fourchette de dates réelles.
   AUCUNE promesse nouvelle : pure traduction de « 6 à 10 jours ouvrés ».
   Remplit tout [data-kdd-livraison] ; MutationObserver pour les nœuds
   réinjectés par le morph (tiroir panier). Sans JS : le texte d'origine reste. */
(function () {
  'use strict';

  var CUTOFF = 17; // heure de Paris
  var PREP_MIN = 1, PREP_MAX = 2, TRANSIT_MIN = 5, TRANSIT_MAX = 8;

  // Jours fériés France métropolitaine (à étendre chaque année).
  var FERIES = {
    '2026-01-01': 1, '2026-04-06': 1, '2026-05-01': 1, '2026-05-08': 1,
    '2026-05-14': 1, '2026-05-25': 1, '2026-07-14': 1, '2026-08-15': 1,
    '2026-11-01': 1, '2026-11-11': 1, '2026-12-25': 1,
    '2027-01-01': 1, '2027-03-29': 1, '2027-05-01': 1, '2027-05-06': 1,
    '2027-05-08': 1, '2027-05-17': 1, '2027-07-14': 1, '2027-08-15': 1,
    '2027-11-01': 1, '2027-11-11': 1, '2027-12-25': 1
  };

  function cle(d) {
    return d.getUTCFullYear() + '-' +
      String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(d.getUTCDate()).padStart(2, '0');
  }

  function ouvre(d) {
    var j = d.getUTCDay();
    return j !== 0 && j !== 6 && !FERIES[cle(d)];
  }

  // n jours ouvrés après d (d non compté), sur un compteur UTC midi (DST-safe).
  function plusOuvres(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) {
      r.setUTCDate(r.getUTCDate() + 1);
      if (ouvre(r)) n--;
    }
    return r;
  }

  function calcule() {
    // « Maintenant » à Paris, projeté sur un compteur UTC midi.
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hour12: false
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    var jour = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12));
    var heure = +p.hour;

    // Jour de prise en compte : avant 17 h un jour ouvré, sinon le prochain ouvré.
    var depart = new Date(jour.getTime());
    if (heure >= CUTOFF || !ouvre(depart)) depart = plusOuvres(depart, 1);

    var tot = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    var debut = plusOuvres(depart, PREP_MIN + TRANSIT_MIN);
    var fin = plusOuvres(depart, PREP_MAX + TRANSIT_MAX);
    var fmt = function (d) {
      return tot.format(new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 12));
    };
    // Forme courte (tiroir mobile, une ligne) : « 17–25 sept. » ou « 28 sept.–6 oct. »
    var moisFmt = new Intl.DateTimeFormat('fr-FR', { month: 'short' });
    var mois = function (d) { return moisFmt.format(new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 12)); };
    var court;
    if (mois(debut) === mois(fin)) court = debut.getUTCDate() + ' au ' + fin.getUTCDate() + ' ' + mois(fin);
    else court = debut.getUTCDate() + ' ' + mois(debut) + ' au ' + fin.getUTCDate() + ' ' + mois(fin);
    return { long: 'entre le ' + fmt(debut) + ' et le ' + fmt(fin), court: court };
  }

  // T4 (deck panier 09.09) — le voyant 17 h. Même calendrier que les dates :
  // heure de Paris, lun–ven, fériés. Trois textes exacts du deck + repli
  // générique (jour férié en semaine) avec le nom du prochain jour ouvré.
  function voyant() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hour12: false
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    var jour = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12));
    var heure = +p.hour;
    if (ouvre(jour) && heure < CUTOFF) {
      return { etat: 'ouvert', txt: 'Avant 17 h, commande prise en compte aujourd’hui' };
    }
    var prochain = plusOuvres(jour, 1);
    var ecart = Math.round((prochain.getTime() - jour.getTime()) / 86400000);
    if (ouvre(jour) && ecart === 1) {
      return { etat: 'ferme', txt: 'Après 17 h, prise en compte demain, jour ouvré' };
    }
    var nom = new Intl.DateTimeFormat('fr-FR', { weekday: 'long' })
      .format(new Date(prochain.getUTCFullYear(), prochain.getUTCMonth(), prochain.getUTCDate(), 12));
    return { etat: 'ferme', txt: 'Prise en compte ' + nom + ', préparation 1 à 2 j ouvrés' };
  }

  function remplirVoyant(racine) {
    var v;
    try { v = voyant(); } catch (e) { return; }
    (racine || document).querySelectorAll('[data-kdd-voyant]').forEach(function (el) {
      if (el.getAttribute('data-kdd-voyant') !== v.etat) el.setAttribute('data-kdd-voyant', v.etat);
      var t = el.querySelector('[data-kdd-voyant-texte]');
      if (t && t.textContent !== v.txt) t.textContent = v.txt;
    });
  }

  var texte = null;
  function pret() {
    if (texte === null) {
      try { texte = calcule(); } catch (e) { texte = false; }
    }
    return !!texte;
  }

  function remplir(racine) {
    var doc = racine || document;
    remplirVoyant(doc);

    // 1. Cibles marquées (tiroir panier — cart-summary.liquid).
    var cibles = doc.querySelectorAll('[data-kdd-livraison]:not([data-kdd-livraison-fait])');
    cibles.forEach(function (el) {
      if (!pret()) return;
      el.textContent = texte.long;
      el.setAttribute('data-kdd-livraison-fait', '1');
    });

    // 1 bis. Forme courte (tiroir mobile, deck panier 09.09).
    doc.querySelectorAll('[data-kdd-livraison-court]:not([data-kdd-livraison-fait])').forEach(function (el) {
      if (!pret()) return;
      el.textContent = texte.court;
      el.setAttribute('data-kdd-livraison-fait', '1');
    });

    // 2. Le bloc « promesse » de la buy-box : un réglage richtext refuse les
    //    attributs data-*, on cible donc la clé du bloc (les blocs text
    //    portent leur clé dans la classe) et on remplace la fourchette.
    doc.querySelectorAll('[class*="__kdd_promesse"] p').forEach(function (p) {
      if (p.getAttribute('data-kdd-livraison-fait')) return;
      if (p.textContent.indexOf('sous 6 à 10 jours ouvrés') === -1) return;
      if (!pret()) return;
      p.innerHTML = p.innerHTML.replace('sous 6 à 10 jours ouvrés', texte.long);
      p.setAttribute('data-kdd-livraison-fait', '1');
    });
  }

  function arme() {
    remplir(document);
    if ('MutationObserver' in window) {
      var attente = null;
      new MutationObserver(function () {
        if (attente) return;
        attente = setTimeout(function () { attente = null; remplir(document); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { remplir(document); });
    // Le voyant suit l'heure : un tiroir laissé ouvert à 16 h 59 change à 17 h.
    setInterval(function () { remplirVoyant(document); }, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arme);
  else arme();
})();
